import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import VisualContent from './VisualContent';
import {
  SLEditModal,
} from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from "~/config/Colors";
import { useSelector } from "react-redux";

export default function RelatorioTicket() {
  const [data, setData] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);
  const [anos, setAnos] = useState([]);
  const [anoAtivo, setAnoAtivo] = useState(new Date().getFullYear());
  const [clientes, setClientes] = useState([]);
  const [clienteFiltro, setClienteFiltro] = useState([]);

  useEffect(() => {
    setLoadedData(false);
  }, [clienteFiltro]);


  useEffect(() => {
    async function handleRequests() {
      api.get('/signed/geral/acessos/check')
        .then(response => setModulos(response.data));

      api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } })
        .then(response => setClientes(response.data));

      setAnos([
        { id: new Date().getFullYear() - 2 },
        { id: new Date().getFullYear() - 1 },
        { id: new Date().getFullYear() },
      ])
    }

    handleRequests();
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-pj"
            requests={{
              findAll: () =>
                api.get('/signed/empresa/gestorprojeto/relatorios/ossrelatorio'),
              findOne: thisData =>
                api.get('/signed/empresa/gestorprojeto/relatorios/osrelatorio', {
                  params: { id: thisData.id },
                }),
            }}
            selects={[
              {
                list: clientes,
                value: "id",
                label: "nomeFantasia",
                outLabel: "Todos os Clientes",
                filter: "projetos.idCliente",
                onChange: (idCliente) => {
                  setClienteFiltro(idCliente);
                }
              },
            ]}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Relatório',
              subTitle: "Filtre e gere o relatório que precisar",
              icone: 'submenu-relatorio',
            }}
          >
          <SLEditModal
            menu={true}
            title="Tickets"
            setter={setMountedData}
          >
            {mountedData && (
              <VisualContent {...{ mountedData }} />
            )}
          </SLEditModal>

            <CustomBodyContent {...{ data, setPageData }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
